import { LitElement, html, css } from 'lit';
import { customElement } from 'lit/decorators';

@customElement('modal-header')
export class ModalHeader extends LitElement {
    protected render() {
        return html`
            <div id="modalHeader">
                <slot></slot>
            </div>
        `;
    }

    static get styles() {
        return css`
            #modalHeader {
                color: var(--main-primary-color);
                margin-bottom: 1rem;
                line-height: 1.5;
                padding-bottom: 0.5rem;
                border-bottom: 1px solid var(--theme-border-color);
                font-weight: bold;
            }
        `;
    }
}
